import { useQuery } from "@apollo/client"
import { ArtistDetailQuery } from "./queries/artists"

export type Country = {
  name?: String
}

export type State = {
  short?: string
}

export type School = {
  name?: string
  city?: string
  state?: State
  country: Country
}

export type Graduation = {
  year?: number
  degreeType?: string
  school?: School
}

export type Organization = {
  name?: string
  city?: string
  state?: State
  country?: Country
}

export type Affiliation = {
  organization?: Organization
}
export type Artist = {
  name: string
  genderPronoun?: string
  livesAndWorks?: string
  birthYear?: string
  hometown?: string
  website?: string
  graduations: [Graduation]
  affiliations: [Affiliation]
}

const graphqlApi = {
  artistDetails: (slug?: string, userId?: string): Artist | undefined =>
    useQuery(ArtistDetailQuery, {
      variables: { slug, userId },
    })?.data?.artist,
}

export default graphqlApi
